import { RegExpUtility } from "../../text/RegExpUtility";

export class WhiteSpaceKeys
{
  static readonly Enter = "Enter";
  static readonly Tab = "Tab";
  static readonly Space = " ";


  static readonly keys:string[] = 
  [
    WhiteSpaceKeys.Enter,
    WhiteSpaceKeys.Tab,
    WhiteSpaceKeys.Space
  ];

  static readonly regex:RegExp = /^(Enter|Tag|\s)$/;
  
  static is( key:string )
  {
    return this.regex.test( key );
  }
}